import { Card, MediaQuery, Divider } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { BundleSection } from "./components/BundleSection";
import { CheckSection } from "./components/CheckSection";
import { CheckSelectionHeader } from "./components/CheckSelectionHeader";
import { CollapsibleSection } from "../../../../../components/collapsible-section/CollapsibleSection";
import { OrderSummary } from "../../../../../components/order-summary/OrderSummary";
import { PackageContext } from "../../PackageContext";
import { PackageStepHeader } from "../PackageStepHeader";
import { PackageStepLayout } from "../PackageStepLayout";

export function CheckSelectionStep() {
  const { t } = useTranslation();
  const { packageData, goToNextStep } = useContext(PackageContext);

  const hasTemplates = packageData.checks.some(
    (check) => !!check.check_arguments.template_ids
  );

  const requiresTemplateSelection =
    hasTemplates &&
    packageData.checks.some(
      (check) =>
        Array.isArray(check.check_arguments.template_ids) &&
        check.check_arguments.template_ids.length === 0
    );

  const isNextDisabled =
    (packageData.checks.length === 0 && packageData.bundles.length === 0) ||
    requiresTemplateSelection;

  const onSearch = () => {};

  return (
    <>
      <MediaQuery lg xl>
        <PackageStepLayout
          onComplete={() => {
            goToNextStep();
          }}
          disableCompletion={isNextDisabled}
          backgroundColor="surface-sunken"
          contentHeader={<CheckSelectionHeader onSearch={onSearch} />}
          rightSideBar={
            <OrderSummary
              checks={packageData.checks}
              bundles={packageData.bundles}
              title={t("Package summary")}
            />
          }
        >
          <Card className={styles.mainContent}>
            <BundleSection />
            <CheckSection />
          </Card>
        </PackageStepLayout>
      </MediaQuery>
      <MediaQuery sm md>
        <PackageStepHeader
          onComplete={() => {
            goToNextStep();
          }}
          isDisabled={isNextDisabled}
        />
        <Divider />
        <div className={styles.mobileLayout}>
          <div className={styles.mobileCard}>
            <CheckSelectionHeader onSearch={onSearch} />
          </div>
          <div
            className={css(
              styles.mobileCard,
              css({
                paddingLeft: "var(--space-1)",
                paddingRight: "var(--space-1)",
              })
            )}
          >
            <CollapsibleSection
              data={
                <OrderSummary
                  checks={packageData.checks}
                  bundles={packageData.bundles}
                />
              }
              title={t("Package summary")}
              testID="package-summary-toggle"
            />
          </div>
          <div className={css(styles.mobileCard, styles.mobileContent)}>
            <BundleSection />
            <CheckSection />
          </div>
        </div>
      </MediaQuery>
    </>
  );
}

const styles = {
  mainContent: css({
    display: "flex",
    flexDirection: "column",
    padding: "var(--space-5) var(--space-5) var(--space-10)",
    gap: "var(--space-10)",
    maxWidth: 976,
    width: "100%",
  }),
  mobileLayout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-3)",
    backgroundColor: "var(--surface-sunken)",
    paddingBottom: "var(--space-5)",
  }),
  mobileCard: css({
    backgroundColor: "var(--surface-base)",
    padding: "var(--space-5) var(--space-4)",
  }),
  mobileContent: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-10)",
  }),
};
